var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"max-width":"1024px","hide-actions":"","no-padding":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":require("@/assets/transpress-3PL-services.jpg")}}),_c('a',{attrs:{"href":"mailto:3PL@transpress.bg?subject=Vote"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }